import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import ChangeOrderStatus from '../components/ChangeOrderStatus';
import ChangeSalesMan from '../components/ChangeSalesMan';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { FaEye } from 'react-icons/fa';


const SalesmanViewUserOrders = () => {
  const { userId } = useParams();
  const location = useLocation();
  const { type } = location.state || {}; 
  const [orders, setOrders] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showChangeSalesMan, setShowChangeSalesMan] = useState(false);
  const [currentSalesman, setCurrentSalesman] = useState(''); 
  const user = useSelector(state => state?.user?.user);
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();


  
  // Default startDate and endDate for the current month
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${SummaryApi.getUserById.url}/${userId}`, {
        method: SummaryApi.getUserById.method,
        credentials: 'include',
      });
      const responseData = await response.json();
      if (responseData.success) {
        setUserDetails(responseData.data || {});
      } else {
        setError(responseData.message);
      }
    } catch (error) {
      
      setError('Error fetching user details');
    } finally {
      setLoading(false);
    }
  };

  const fetchUserOrders = async () => {
    try {
      
  
      const query = new URLSearchParams({
        type,
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : '',
      }).toString();
  
      const response = await fetch(`${SummaryApi.adminViewUserOrders.url}/${userId}?${query}`, {
        method: SummaryApi.adminViewUserOrders.method,
        credentials: 'include',
      });
  
      const responseData = await response.json();
      if (responseData.success) {
        setOrders(responseData.data || []);
      } else {
        setOrders([]);
      }
    } catch (error) {
      setOrders([]);
    }
  };

  useEffect(() => {
    fetchUserDetails();
    fetchUserOrders(); 
  }, [userId]);

  useEffect(() => {
    fetchUserOrders(); 
  }, [startDate, endDate]);


  const closeModal = () => {
    setSelectedOrderId(null);
    setSelectedStatus('');
    setShowChangeSalesMan(false); 
  };

  const refreshData = async () => {
    await fetchUserOrders(); 
    await fetchUserDetails();
};


useEffect(() => {
  setLoadingPage(true);
  const loadingTimeout = setTimeout(() => {
    
    setLoadingPage(false);
    navigate("/");
  }, 10000); 

  if (user) {
    if (user?.role !== ROLE.SALESMAN) {
      navigate('/');
      setLoadingPage(false);
    } 
   
      else{
          setLoadingPage(false);
          clearTimeout(loadingTimeout);
      }
     
    
  } 

  // Clear the timeout when the component unmounts or the effect is rerun
  return () => clearTimeout(loadingTimeout);
}, [user, navigate]);

if (loadingPage) {
  return (
      <div className="flex justify-center items-center h-screen">
          <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
  );
}
const getStatusColor = (status) => {
    switch (status) {
      case 'accepted':
        return 'bg-blue-900 text-white';
      case 'done':
        return 'bg-green-700 text-white';
      case 'pending':
        return 'bg-yellow-600 text-white';
      case 'rejected':
        return 'bg-red-800 text-white';
        case 'refused':
          return 'bg-red-900 text-white';
      default:
        return 'bg-gray-700 text-white';
    }
  };
  const handleViewOrder = (orderId, type) => {
    navigate(`/salesManPanel/salesManViewUserOrderDetails/${orderId}/${type}`, {
      state: { userDetails }
    });
  };


  return (
    <div className="min-h-[calc(100vh-120px)] flex flex-col">
      {/* User Details Section */}
      <div className="bg-white p-4 mb-4 border border-gray-300 rounded">
        {loading ? (
          <p>جاري التحميل</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <div className="mb-4 p-4 border border-gray-300 bg-gray-100 rounded ">
                    <h2 className="text-xl font-bold mb-2">معلومات المستخدم</h2>
                    {userDetails.profilePic && (
                        <img src={userDetails.profilePic} alt="Profile" className="w-24 h-24 rounded-full" />
                    )}
                    <p className="mb-1"> {userDetails.name || 'N/A'}<strong>: الاسم</strong></p>
                    <p className="mb-1">{userDetails.email || 'N/A'} <strong>: البريد الالكترونى</strong> </p>

                    {type==='Medicine' &&
                    <p className="mb-1">
                        {userDetails?.medicineDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.medicineDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }
                    {type==='Cosmetic' &&
                    <p className="mb-1">
                        {userDetails?.cosmeticDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.cosmeticDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }

                    <p className="mb-1"> {userDetails.shippingAddress || 'N/A'} <strong>: العنوان</strong></p>
                    <p className="mb-1"> {userDetails.mobileNumber || 'N/A'} <strong>: رقم الهاتف المحمول</strong></p>

                </div>
        )}
      </div>

{/* Date Filter Section */}
<div className="flex justify-end items-start mb-4">
  <div className="text-right">
    <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها فواتير المستخدم</h2>

    <div className="flex gap-6 justify-end">
      {/* Start Date */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          تاريخ البداية
        </label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>

      {/* End Date */}
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          تاريخ النهاية
        </label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>
    </div>
  </div>
</div>


      {/* Orders Section */}
<main className="w-full h-full p-4 text-right">
  {orders.length === 0 ? (
    <p>لا يوجد فواتير متاحة في هذه الفتره الزمنية</p>
  ) : (<div className='overflow-x-auto'>
    <table className='w-full border-collapse border border-gray-300'>
      <thead>
        <tr className='bg-black text-white'>
        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">كود الطلب[المرتجع]</th>
        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تم  بواسطة</th>
          <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">اسم مندوب المبيعات</th>
         {/* <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">البريد الالكتروني مندوب المبيعات</th>*/}
       {/*  <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">اسم الشركة</th>* */} 
          <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تاريخ الطلب</th>
          <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">السعر الاجمالى</th>
          <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">حالة الطلب</th>
          <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تفاصيل الطلب</th>
          
        </tr>
      </thead>
      <tbody>
        {orders.map((item, index) => (
          <tr key={item._id || index} className="min-h-[80px] border-t border-gray-300">
          {item.type==='order'&& <td className="text-center py-2 px-4 border border-gray-300">#{item.orderCode}</td>}  
          {item.type==='refund'&& <td className="text-center py-2 px-4 border border-gray-300">#{item.orderCode}--[#{item.refundFromOrderNumber}]</td>}  
         {item.type==='order'&& item.orderSalesManName &&<td className="text-center py-2 px-6 border border-gray-300"> مندوب المبيعات ({item.orderSalesManName})</td>}
         {item.type==='order'&& item.orderSalesManName==='' &&<td className="text-center py-2 px-6 border border-gray-300">الصيدلية </td>}
         {item.type==='refund'&& item.refundSalesManName &&<td className="text-center py-2 px-6 border border-gray-300"> مندوب المبيعات ({item.refundSalesManName})</td>}
         {item.type==='refund'&& item.refundSalesManName==='' &&<td className="text-center py-2 px-6 border border-gray-300">الصيدلية </td>}
            <td className="text-center py-2 px-6 border border-gray-300">{item.salesManName || 'لم يتم تعيين مندوب مبيعات لهذه العملية بعد'}</td>
           {/* <td className="text-center py-2 px-6 border border-gray-300">{item.salesManEmail || 'لم يتم تعيين مندوب مبيعات لهذه العملية بعد'}</td>*/}
         {/*   <td className="text-center py-2 px-6 border border-gray-300">
              {item.paymentSource === 'شركة دواكو' ? 'شركة دواكو' : 'شركة مستحضرات التجميل'}
            </td>*/} 
            <td className="text-center py-2 px-6 border border-gray-300">{moment(item.createdAt).format('LLL')}</td>
            <td className="text-center py-2 px-6 border border-gray-300">
              {displayINRCurrency(item.totalPrice?.toString())}
          </td>

            <td className={`text-center py-2 px-6 border border-gray-300 ${getStatusColor(item.status)}`}>
              {item.status === 'accepted' && 'تم تحضير الطلب وجاهز للتوصيل'}
              {item.status === 'done' &&item.type==='order'&& ' تم ايصال الطلب بنجاح'} 
              {item.status === 'done' &&item.type==='refund'&& ' طلب مرتجع مقبول'}
              {item.status === 'rejected' && 'تم رفض الطلب'}
              {item.status === 'refused' && 'تم رفض الطلب'}
              {item.status === 'pending' && 'جاري تحضير الطلب بالمخزن'}
              {item.status !== 'accepted' && item.status !== 'rejected' && item.status !== 'pending' && item.status !== 'done' &&item.status !== 'refused' && item.status}
            </td>
            <td className="text-center py-2 px-6 border border-gray-300">
              <div className="flex items-center justify-center cursor-pointer" onClick={() => handleViewOrder(
                  item._id, 
                  item.paymentSource = 'Medicine' 
                )}>
                <FaEye className="text-blue-600 mr-2" />
                <span className="text-blue-600">اضغط هنا للتفاصيل</span>
              </div>
            </td>
            
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  )}
</main>








    </div>
  );
};
    
export default SalesmanViewUserOrders;
